module.exports = __webpack_public_path__ + "static/img/landAnalyze.742aa21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landAnalyze.jpg
// module id = rzMY
// module chunks = 1